import React, {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';

import {groupTitle} from '../../constants';
import AccardionLike from '../../../../../module/newShop/advertisementRegisteration/accadionlikeAR';
import {RootState} from '../../../../../store/redux';
import {
  addFormData,
  addOptionalFormData,
  addRegisterAdvertisement,
} from '../../../../../store/redux/advertisementRegisteration';
import ProvidedRentMachineryForm from './providedRentMachineryForm';
import ProvidedRentFarmForm from './providedRentFarmForm';
import WantedRentMachineryForm from './wantedRentMachineryForm';
import WantedRentFarmForm from './wantedRentFarmForm';
import {ISaleBuyRentService} from '../../types';
import {CodeToInputGroupName} from '../../../myFavouriteAdd/card/helper';
import useGetAdCatalog from '../../../../../services/hookService/getAdCatalog/useGetAdCatalog';
import {clearAllData} from '../../../../../store/redux/addPictureAdvertisment';
import {getRestrictedInputGroups} from '../../../../../global/helpers/getRestrictedInputGroups';
import {AdvertisementType} from '../../../../../utilities/helper/unitGenerator/unit.types';
function Rent({
  srs_type,
  storePlanType,
  isLoading,
  setOpenInputListBottomSheet,
  setModalText,
  guid,
  unitData,
}: ISaleBuyRentService) {
  const dispatch = useDispatch();

  const {input, input_group, rentBottomSheetData, ad_type} = useSelector(
    (state: RootState) => state.advertisementRegisteration,
  );
  const isPersonalAd = ad_type.value === 'personal';
  const restrictedInputGroups = getRestrictedInputGroups({
    adType: ad_type.value,
    storePlanType: storePlanType!,
    advertisementType: AdvertisementType.PROVIDED_RENT,
  });
  const {addCatalogData} = useGetAdCatalog({parent: guid});

  const handleAccordionLike = (
    item: Omit<IInputGroup, 'title_description' | 'icon'>,
  ) => {
    dispatch(
      addRegisterAdvertisement({
        input_group: {
          guid: item.guid,
          code: item.code,
          type: CodeToInputGroupName[item.code],
        },
      }),
    );
    dispatch(
      addRegisterAdvertisement({
        input: undefined,
        sub_input: undefined,
      }),
    );
    dispatch(addFormData(''));
  };

  useEffect(() => {
    if (ad_type?.value === 'store') {
      dispatch(
        addRegisterAdvertisement({
          rentBottomSheetData: 'providedRent',
        }),
      );
    }
  }, [ad_type?.value]);

  return (
    <div>
      {rentBottomSheetData && (
        <>
          <section className="mb-3">
            <p className="mt-3 text-md">
              {groupTitle[srs_type.type + rentBottomSheetData]}
            </p>
            {addCatalogData &&
              addCatalogData[0]?.input_Group_object?.map(
                (item: IInputGropuList, index: number) => {
                  return (
                    <AccardionLike
                      key={item.guid ?? item.code ?? index}
                      logo={item.image}
                      title={item.title}
                      disable={
                        isPersonalAd
                          ? false
                          : !restrictedInputGroups.includes(item.code)
                      }
                      active={input_group?.guid === item.guid}
                      activeInput={
                        input_group?.guid === item.guid ? input : undefined
                      }
                      onClick={() => {
                        handleAccordionLike(item);
                        setOpenInputListBottomSheet(true);
                        dispatch(addOptionalFormData(''));
                        dispatch(addFormData(''));
                        dispatch(addRegisterAdvertisement({}));
                        dispatch(clearAllData());
                      }}
                      onRemoveItem={() => {
                        dispatch(
                          addRegisterAdvertisement({
                            input: undefined,
                            sub_input: undefined,
                          }),
                        );
                        dispatch(addFormData(''));
                      }}
                    />
                  );
                },
              )}
          </section>
          {input?.title && (
            <>
              {rentBottomSheetData === 'providedRent' &&
                input_group?.code === 15 && (
                  <ProvidedRentMachineryForm isLoading={isLoading} />
                )}
              {rentBottomSheetData === 'providedRent' &&
                input_group?.code === 17 && (
                  <ProvidedRentFarmForm isLoading={isLoading} />
                )}
              {rentBottomSheetData === 'wantedRent' &&
                input_group?.code === 15 && (
                  <WantedRentMachineryForm
                    setModalText={setModalText}
                    isLoading={isLoading}
                  />
                )}
              {rentBottomSheetData === 'wantedRent' &&
                input_group?.code === 17 && (
                  <WantedRentFarmForm
                    setModalText={setModalText}
                    isLoading={isLoading}
                  />
                )}
            </>
          )}
        </>
      )}
    </div>
  );
}

export default React.memo(Rent);
